import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

const parseToBoolean = value => value.trim().toLowerCase() === "true";

const I18nBoolean = ({ value = false }) => {
  const booleanValue = value instanceof String ? parseToBoolean(value) : value;
  return booleanValue ? <FormattedMessage id="common.yes" /> : <FormattedMessage id="common.no" />;
};

I18nBoolean.propTypes = {
  /**
   * Boolean value
   **/
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default I18nBoolean;
